// cumulative function. What is p(o<=x)
function cumulative(pdf){
    const reducer = (accumulator, currentValue) => {
        return accumulator.length === 0 ? [currentValue] : accumulator.concat([accumulator[accumulator.length-1] + currentValue]);
    };
    return pdf.reduce(reducer, []);

}

// If p(o<=x) == pValue, what is x?
// returns a two-member array [minX, maxX]
function inverseCumulative(pdf, pValue) {
    const TOLERANCE=0.000001;  // TODO eliminate?
    let cum = cumulative(pdf);
    let maxX = pdf.length - 1;
    for (let x=0; x<cum.length; x++) {
        if (pValue + TOLERANCE <= cum[x]) {
            maxX = x;
            break;
        }
    }

    let minX = 0;
    for (let x=cum.length-1; x>=0; x--) {
        if (cum[x] < pValue - TOLERANCE) {
            minX = x + 1;
            break;
        }
    }
    return [minX, maxX];
}

function mean(pdf) {
    let m = 0;
    for (let x=0; x<pdf.length; x++) {
        m += x * pdf[x];
    }
    return m;
}

function normalize(x) {
    const reducer = (accumulator, currentValue) => accumulator + currentValue;
    let sum = x.reduce(reducer, 0);
    return x.map(v => { return v/sum; });
}

export { normalize, cumulative, mean, inverseCumulative };



// WEBPACK FOOTER //
// ./src/lib/prob.js